<template>
  <header class="ball-hero" :style="backgroundStyle">
    <v-container>
      <p>{{ event.hero.eyebrow || `Reckon Ball ${event.year}` }}</p>
      <h1>{{ event.hero.title }}</h1>
      <h2 v-if="event.hero.subtitle">{{ event.hero.subtitle }}</h2>
      <p class="summary">{{ event.hero.summary }}</p>
      <ul aria-label="Event details">
        <li>{{ event.hotel.name }}</li><li>{{ event.dining.restaurant }}</li><li>{{ locationLabel }}</li>
      </ul>
    </v-container>
  </header>
</template>
<script>
export default {
  name: 'ReckonBallHero',
  props: { event: { type: Object, required: true } },
  computed: {
    backgroundStyle() {
      const source = this.$options.filters.mediaSrc(this.event.hero.image);
      return source ? { backgroundImage: `linear-gradient(90deg, rgba(0,0,0,.96), rgba(0,0,0,.42)), url(${source})` } : null;
    },
    locationLabel() { return [this.event.location.neighborhood, this.event.location.city, this.event.location.state].filter(Boolean).join(', '); },
  },
};
</script>
<style scoped>
.ball-hero { background-color: #080808; background-position: center; background-size: cover; border-bottom: 1px solid #46371f; min-height: 650px; padding: 120px 0 90px; }
.ball-hero .container > p:first-child { color: #c8a45e; font-family: "Oswald", sans-serif; font-weight: 900; letter-spacing: .08em; margin: 0 0 14px; text-transform: uppercase; }
h1 { color: #fff8e9; font-family: Georgia, serif; font-size: clamp(3.4rem, 9vw, 7rem); font-weight: 400; line-height: .96; margin: 0; max-width: 900px; }
h2 { color: #e2d4b8; font-family: Georgia, serif; font-size: clamp(1.25rem, 3vw, 2rem); font-weight: 400; margin: 18px 0 0; }
.summary { color: #ded8cd; font-size: 1.14rem; line-height: 1.7; margin: 30px 0 0; max-width: 770px; }
ul { display: flex; flex-wrap: wrap; gap: 8px; list-style: none; margin: 28px 0 0; padding: 0; }
li { border: 1px solid #8a7040; border-radius: 999px; color: #fff3d7; font-size: .76rem; padding: 7px 12px; }
@media (max-width: 600px) { .ball-hero { min-height: 0; padding: 70px 0 60px; } }
</style>
